import * as Schema from "effect/Schema";

/**
 * ButtonWidget — a themed call-to-action backed by a real Duro component:
 * `<LinkButton>` when `href` is set, otherwise `<Button>`. `variant`/`size` map
 * onto Duro's own button API (a LinkButton coerces to primary|secondary).
 * `type: "submit"` makes it submit the form its section is (a plain Duro
 * `<Button type="submit">`; `href` is ignored then).
 */
export const ButtonWidgetContent = Schema.Struct({
  contentType: Schema.Literal("button"),
  label: Schema.String,
  href: Schema.optional(Schema.String),
  variant: Schema.optional(
    Schema.Literal(
      "primary",
      "secondary",
      "inverseSecondary",
      "link",
      "danger",
    ),
  ),
  size: Schema.optional(Schema.Literal("default", "small")),
  type: Schema.optional(Schema.Literal("link", "submit")),
  /** Placement in its cell (Duro `Inline justify`); absent = start. */
  align: Schema.optional(Schema.Literal("start", "center", "end")),
  /** Width in its cell: its own (`hug`, the default) or the cell's (`fill`,
   *  the design system's `fullWidth`). The label keeps its size either way. */
  width: Schema.optional(Schema.Literal("hug", "fill")),
  /** Vertical placement in its cell; absent = top. The button keeps its own
   *  height: a taller cell is space around it, not a taller button. */
  valign: Schema.optional(Schema.Literal("top", "middle", "bottom")),
});
export type ButtonWidgetContent = Schema.Schema.Type<
  typeof ButtonWidgetContent
>;
